
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 36","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0C5.372 0 0 5.372 0 12c0 2.185.583 4.233 1.604 5.997C3.678 21.586 12 36 12 36s8.319-14.412 10.395-17.999A11.948 11.948 0 0024 12c0-6.628-5.372-12-12-12zm8.663 16.999C19.188 19.551 14.554 27.576 12 32L3.335 16.996A9.99 9.99 0 012 12C2 6.486 6.486 2 12 2s10 4.486 10 10a9.986 9.986 0 01-1.337 4.999z"}}),_c('path',{attrs:{"d":"M12 6c-3.313 0-6 2.688-6 6s2.688 6 6 6 6-2.688 6-6-2.687-6-6-6zm0 10c-2.208 0-4-1.792-4-4s1.792-4 4-4 4 1.792 4 4-1.792 4-4 4z"}})])
          )
        }
      }
    